import { Component, ElementRef, Input, Output, OnInit, OnDestroy, Renderer2, EventEmitter } from '@angular/core';
import { ModalService } from './modal.service';
import { PageService } from '../page.service';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() titulo: string;

  @Input() sucessoBotao = true;
  @Input() sucessoBotaoDisabled = false;
  @Input() sucessoBotaoNome = 'OK';
  @Input() sucessoBotaoIcone: string;
  @Input() cancelarBotao = false;
  @Input() cancelarBotaoDisabled = false;
  @Input() cancelarBotaoIcone: string;
  @Input() cancelarBotaoNome = 'Cancelar';
  @Input() fecharOnClick = true;
  @Input() alinharBtnsCentro = false;

  @Output() onSucesso: EventEmitter<any> = new EventEmitter();
  @Output() onCancelar: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onOpen: EventEmitter<any> = new EventEmitter();

  element: any;
  isOpen = false;

  constructor(
    private modalService: ModalService,
    private page: PageService,
    private _element: ElementRef,
    private _renderer: Renderer2) {

    this.element = _element.nativeElement;
  }

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  onSuccessEvent(): void {
    this.onSucesso.emit();
    if (this.fecharOnClick) {
      this.close();
    }
  }

  onCancelEvent(): void {
    this.onCancelar.emit();
    if (this.fecharOnClick) {
      this.close();
    }
  }

  // remove self from modal service when directive is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.parentNode.removeChild(this.element);
  }

  // open modal
  open(): void {
    this.isOpen = true;
    this._renderer.addClass(this.element, 'modal-open');
    this.page.lockScroll();
    this.onOpen.emit();
  }

  // close modal
  close(): void {
    this.isOpen = false;
    this._renderer.removeClass(this.element, 'modal-open');
    this.page.unlockScroll();
    this.onClose.emit();
  }
}
